export default "__VITE_ASSET__Cb6eaLwY__"